import { Duration } from '@afz/base-library';
export const DEFAULT_CRIPTO_MODE = 'AES-GCM';
export const DEFAULT_CRIPTO_LENGTH = 256;
export const DEFAULT_CRIPTO_IV_LENGTH = 12;
export const DEFAULT_CRIPTO_KEY_ALG = 'PBKDF2';
export const DEFAULT_CRIPTO_KEY_HASH = 'SHA-256';
export const DEFAULT_CRIPTO_KEY_SALT = 'CO4UgOgn-sVqqaWU';
export const DEFAULT_CRIPTO_KEY_ITERATIONS = 1000;
export const DEFAULT_COOKIE_KEY = 'afzSession';
export const DEFAULT_COOKIE_PATH = '/';
export const DEFAULT_COOKIE_CHECK_INTERVAL = Duration.fromISO('PT30S');
//# sourceMappingURL=constants.js.map